import { render, staticRenderFns } from "./GovernmentComp.vue?vue&type=template&id=4064af6e&scoped=true&"
import script from "./GovernmentComp.vue?vue&type=script&lang=js&"
export * from "./GovernmentComp.vue?vue&type=script&lang=js&"
import style0 from "./GovernmentComp.vue?vue&type=style&index=0&id=4064af6e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4064af6e",
  null
  
)

export default component.exports